/* Second Bloom — Saved page: saved pieces, sold state, picks in the shopper's size */
(function () {
  if (customElements.get('sb-saved')) return;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(cents) {
    if (cents == null || isNaN(cents)) return '';
    return 'EGP ' + Math.round(cents / 100).toLocaleString('en-US');
  }
  function sizeOf(title) {
    var m = String(title || '').match(/Size:\s*(.+)$/i);
    return m ? m[1].trim() : null;
  }
  function imgUrl(u, w) {
    if (!u) return '';
    if (typeof u === 'object') u = u.src || '';
    if (u.indexOf('//') === 0) u = 'https:' + u;
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function norm(p) {
    var variants = p.variants || [];
    var price = typeof p.price === 'number' ? p.price
      : Math.round(parseFloat((variants[0] && variants[0].price) || 0) * 100);
    var available = typeof p.available === 'boolean' ? p.available
      : variants.some(function (v) { return v.available; });
    var img = p.featured_image || (p.images && p.images[0]) || '';
    return { h: p.handle, title: p.title, price: price, img: img, available: available };
  }

  class SBSaved extends HTMLElement {
    connectedCallback() {
      this.grid = this.querySelector('[data-sb-saved-grid]');
      this.empty = this.querySelector('[data-sb-saved-empty]');
      this.countEl = this.querySelector('[data-sb-saved-count-label]');
      this.picks = this.querySelector('[data-sb-picks]');
      this.picksRow = this.querySelector('[data-sb-picks-row]');
      this.picksSub = this.querySelector('[data-sb-picks-sub]');
      this.sizesEl = this.querySelector('[data-sb-sizes]');
      this.products = new Map();
      this.pool = [];
      this.size = null;

      this.addEventListener('click', (e) => {
        var add = e.target.closest('[data-sb-add]');
        if (add) { e.preventDefault(); this.addToCart(add); return; }
        var media = e.target.closest('[data-sb-href]');
        if (media && !e.target.closest('.sbn-heart')) { window.location.href = media.dataset.sbHref; return; }
        var size = e.target.closest('[data-sb-size]');
        if (size) { this.size = size.dataset.sbSize; this.renderPicks(); }
      });
      document.addEventListener('sb:favourites-changed', () => { this.render(); this.renderPicks(); this.fetchMissing(); });

      if (!window.SBFav) { this.render(); return; }
      this.load();
    }

    async load() {
      var list = window.SBFav.list();
      await Promise.all(list.map(async (it) => {
        try {
          var r = await fetch('/products/' + encodeURIComponent(it.h) + '.js');
          this.products.set(it.h, r.ok ? await r.json() : null);
        } catch (e) { this.products.set(it.h, null); }
      }));
      this.render();
      this.loadPicks();
    }

    async fetchMissing() {
      if (!window.SBFav || this.fetching) return;
      var missing = window.SBFav.list().filter((it) => !this.products.has(it.h));
      if (!missing.length) return;
      this.fetching = true;
      await Promise.all(missing.map(async (it) => {
        try {
          var r = await fetch('/products/' + encodeURIComponent(it.h) + '.js');
          this.products.set(it.h, r.ok ? await r.json() : null);
        } catch (e) { this.products.set(it.h, null); }
      }));
      this.fetching = false;
      this.render();
    }

    items() {
      var list = window.SBFav ? window.SBFav.list() : [];
      return list.map((it) => {
        var p = this.products.get(it.h);
        var v = p && (p.variants.find(function (x) { return x.available; }) || p.variants[0]);
        return {
          h: it.h,
          id: p ? p.id : it.id,
          title: p ? p.title : (it.title || ''),
          vendor: p ? p.vendor : (it.vendor || ''),
          type: p ? p.type : (it.type || ''),
          price: p ? p.price : it.price,
          img: p ? p.featured_image : it.img,
          available: p === undefined ? null : !!(p && p.available),
          variant: v ? v.id : null
        };
      });
    }

    render() {
      var items = this.items();
      var n = items.length;
      if (this.countEl) this.countEl.textContent = n ? (n === 1 ? '1 piece' : n + ' pieces') : '';
      this.empty.hidden = n > 0;
      this.grid.hidden = n === 0;
      var fallback = this.dataset.fallback || '/collections/all';
      this.grid.innerHTML = items.map(function (i) {
        var url = '/products/' + encodeURIComponent(i.h);
        var similar = i.type ? '/search?type=product&q=' + encodeURIComponent(i.type) : fallback;
        var sold = i.available === false;
        return '<div class="sbn-card' + (sold ? ' is-sold' : '') + '">' +
          '<div class="sbn-card__media" data-sb-href="' + url + '">' +
          (i.img ? '<img src="' + esc(imgUrl(i.img, 600)) + '" alt="" loading="lazy">' : '') +
          (sold ? '<span class="sbn-card__sold">Sold</span>' : '') +
          '<button type="button" class="sbn-heart is-saved" data-sb-handle="' + esc(i.h) + '" aria-pressed="true" aria-label="Remove ' + esc(i.title) + ' from saved">' + window.SBFav.heart + '</button></div>' +
          (i.vendor ? '<div class="sbn-card__vendor">' + esc(i.vendor) + '</div>' : '') +
          '<a class="sbn-card__title" href="' + url + '">' + esc(i.title) + '</a>' +
          '<div class="sbn-card__price">' + money(i.price) + '</div>' +
          (i.available && i.variant
            ? '<button type="button" class="sbn-btn" data-sb-add="' + i.variant + '">Add to cart</button>'
            : sold
              ? '<a class="sbn-btn sbn-btn--ghost" href="' + esc(similar) + '">See similar</a>'
              : '<a class="sbn-btn sbn-btn--ghost" href="' + url + '">View piece</a>') +
          '</div>';
      }).join('');
    }

    async addToCart(btn) {
      if (btn.disabled) return;
      var label = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Adding…';
      try {
        var r = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(btn.dataset.sbAdd), quantity: 1 }] })
        });
        if (!r.ok) { btn.textContent = 'Already in your cart'; return; }
        btn.textContent = 'Added';
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        var d = document.getElementById('Cart-Drawer');
        if (d && typeof d.open === 'function') setTimeout(function () { d.open(); }, 250);
        else window.location.href = '/cart';
      } catch (e) {
        btn.textContent = label;
        btn.disabled = false;
      }
    }

    async loadPicks() {
      var items = this.items();
      var sizes = [];
      items.forEach(function (i) { var s = sizeOf(i.title); if (s && sizes.indexOf(s) === -1) sizes.push(s); });
      if (!sizes.length) { this.picks.hidden = true; return; }
      this.sizes = sizes;
      this.size = sizes[0];

      var pool = [];
      var ids = items.filter(function (i) { return i.id; }).slice(0, 4).map(function (i) { return i.id; });
      for (var k = 0; k < ids.length; k++) {
        try {
          var r = await fetch('/recommendations/products.json?product_id=' + ids[k] + '&limit=10&intent=related');
          if (r.ok) { var j = await r.json(); pool = pool.concat(j.products || []); }
        } catch (e) {}
      }
      try {
        var base = (this.dataset.fallback || '/collections/all').replace(/\/$/, '');
        var r2 = await fetch(base + '/products.json?limit=250');
        if (r2.ok) { var j2 = await r2.json(); pool = pool.concat(j2.products || []); }
      } catch (e) {}

      var seen = {};
      this.pool = pool.map(norm).filter(function (p) {
        if (!p.h || !p.available || seen[p.h]) return false;
        seen[p.h] = true;
        return true;
      });
      this.renderPicks();
    }

    renderPicks() {
      if (!this.sizes || !this.sizes.length || !window.SBFav) return;
      var saved = {};
      window.SBFav.list().forEach(function (x) { saved[x.h] = true; });
      var size = this.size;
      this.picks.hidden = false;
      this.picksSub.textContent = 'In size ' + size + ', based on what you saved';
      this.sizesEl.innerHTML = this.sizes.map(function (s) {
        return '<button type="button" data-sb-size="' + esc(s) + '" aria-pressed="' + (s === size) + '">' + esc(s) + '</button>';
      }).join('');
      var picks = this.pool.filter(function (p) { return !saved[p.h] && sizeOf(p.title) === size; }).slice(0, 12);
      if (!picks.length) {
        this.picksRow.innerHTML = '<p class="sbn-picks__none">Nothing in size ' + esc(size) + ' right now. New pieces drop every week.</p>';
        return;
      }
      this.picksRow.innerHTML = picks.map(function (p) {
        var url = '/products/' + encodeURIComponent(p.h);
        return '<div class="sbn-pick"><div class="sbn-pick__media" data-sb-href="' + url + '">' +
          (p.img ? '<img src="' + esc(imgUrl(p.img, 400)) + '" alt="" loading="lazy">' : '') +
          '<button type="button" class="sbn-heart" data-sb-handle="' + esc(p.h) + '" aria-pressed="false" aria-label="Save ' + esc(p.title) + '">' + window.SBFav.heart + '</button></div>' +
          '<a class="sbn-pick__title" href="' + url + '">' + esc(p.title) + '</a>' +
          '<div class="sbn-pick__price">' + money(p.price) + '</div></div>';
      }).join('');
    }
  }

  customElements.define('sb-saved', SBSaved);
})();
